<template>
  <div v-if="item">
    <resource-info-panel
      v-if="item.type == 'resource'"
      :resource="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <target-info-panel
      v-else-if="item.type == 'target'"
      :target="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <index-info-panel
      v-else-if="item.type == 'index'"
      :index="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <flow-info-panel
      v-else-if="item.type == 'flow'"
      :flow="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <flow-branch-info-panel
      v-else-if="item.type == 'flowBranch'"
      :flowBranch="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <relation-info-panel
      v-else-if="item.type == 'relation'"
      :relation="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <action-info-panel
      v-else-if="item.type == 'action'"
      :action="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <incident-info-panel
      v-else-if="item.type == 'incident'"
      :incident="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <momentum-info-panel
      v-else-if="item.type == 'momentum'"
      :momentum="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <stakeholder-info-panel
      v-else-if="item.type == 'stakeholder'"
      :stakeholder="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <scenario-info-panel
      v-else-if="item.type == 'scenario'"
      :scenario="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
    <simulation-info-panel
      v-else-if="item.type == 'simulation'"
      :simulation="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />

    <model-info-panel
      v-else-if="item.type == 'model'"
      :model="item"
      :back-visible="backVisible"
      @close="close()"
      @back="back()"
      @select="select($event)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, watch } from "vue";
import { onBeforeRouteUpdate } from "vue-router";

import ResourceInfoPanel from "@editor/items/resource/ResourceInfoPanel.vue";
import TargetInfoPanel from "@editor/items/target/TargetInfoPanel.vue";
import IndexInfoPanel from "@editor/items/index/IndexInfoPanel.vue";
import FlowInfoPanel from "@editor/items/flow/FlowInfoPanel.vue";
import FlowBranchInfoPanel from "@editor/items/flow/FlowBranchInfoPanel.vue";
import RelationInfoPanel from "@editor/items/relation/RelationInfoPanel.vue";
import ActionInfoPanel from "@editor/items/action/ActionInfoPanel.vue";
import IncidentInfoPanel from "@editor/items/incident/IncidentInfoPanel.vue";
import MomentumInfoPanel from "@editor/items/momentum/MomentumInfoPanel.vue";
import StakeholderInfoPanel from "@editor/items/stakeholder/StakeholderInfoPanel.vue";
import ScenarioInfoPanel from "@editor/items/scenario/ScenarioInfoPanel.vue";
import SimulationInfoPanel from "@editor/items/simulation/SimulationInfoPanel.vue";
import ModelInfoPanel from "@editor/items/model/ModelInfoPanel.vue";

import { useOverlay } from "@editor/ui/overlayDialog.store";
import type { OverlayDialogItemRequest } from "./OverlayDialogItem";

const overlay = useOverlay();
const item = computed(() => overlay.item);

const path = reactive([] as OverlayDialogItemRequest[]);

const backVisible = computed(() => path.length > 1);

watch(item, (item, oldItem) => {
  if (oldItem == null && item != null) {
    clearPath();
    if (item.id != null) {
      path.push({ type: item.type, id: item.id });
    } else {
      path.push({ type: item.type });
    }
  }
});

function select(item: OverlayDialogItemRequest) {
  overlay.setItem(item);
  path.push(item);
}

function back() {
  if (path.length > 1) {
    path.pop();
    overlay.setItem(path[path.length - 1]);
  } else {
    overlay.close();
  }
}

function clearPath() {
  path.splice(0, path.length);
}

function close() {
  clearPath();
  overlay.close();
}

onBeforeRouteUpdate(() => {
  close();
});
</script>
